import { PASSWORD_MIN_LENGTH, PASSWORD_REQUIREMENT_HINT, SetPasswordParams } from "@pentacode/core";
import "@pentacode/ui/components";
import { LitElement, css, html } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { app, router } from "../init";
import { validateNewPasswordInputs } from "../lib/password-input";
import { mixins, shared } from "../styles";
import { alert } from "./alert-dialog";

@customElement("ptc-set-password")
export class SetPassword extends LitElement {
    @query("form")
    _form: HTMLFormElement;

    @query("input[name='password']")
    private _passwordInput: HTMLInputElement;

    @query("input[name='repeatPassword']")
    private _repeatPasswordInput: HTMLInputElement;

    @property()
    private _loading = false;

    private async _submit(e: FocusEvent) {
        e.preventDefault();

        this._loading = true;

        const password = new FormData(this._form).get("password") as string;

        try {
            await app.api.setPassword(
                new SetPasswordParams({
                    id: parseInt(router.params.id),
                    token: router.params.token,
                    password,
                })
            );
            await alert("Passwort erfolgreich geändert!", { options: ["Einloggen"], type: "success" });
            router.go("login", { email: router.params.email });
        } catch (e) {
            await alert(e.message, { type: "warning" });
        }

        this._loading = false;
    }

    private _checkPasswordInputs() {
        validateNewPasswordInputs(this._passwordInput, this._repeatPasswordInput, { email: router.params.email });
    }

    static styles = [
        shared,
        css`
            :host {
                ${mixins.fullbleed()};
                ${mixins.scroll()};
                z-index: 100;
                background: #fafafa;
                padding: 2em;
            }

            .logo {
                width: 20em;
            }

            .wrapper {
                width: 100%;
                max-width: 25em;
            }
        `,
    ];

    render() {
        return html`
            <div class="fullbleed vertical centering layout">
                <ptc-ui-logo variant="full" class="margined logo"></ptc-ui-logo>

                <div class="wrapper text-centering">
                    <h1>Passwort Wählen</h1>

                    <div class="margined">
                        Bitte wählen Sie ein neues Passwort für den Account <strong>${router.params.email}</strong>!
                    </div>

                    <div class="card double-margined double-padded vertical layout">
                        <form class="vertical layout" @input=${this._checkPasswordInputs} @submit=${this._submit}>
                            <div class="field">
                                <input
                                    type="password"
                                    name="password"
                                    placeholder="Neues Passwort"
                                    required
                                    minlength=${PASSWORD_MIN_LENGTH}
                                />
                                <div class="small subtle">${PASSWORD_REQUIREMENT_HINT}</div>
                            </div>

                            <div class="field">
                                <input
                                    type="password"
                                    name="repeatPassword"
                                    placeholder="Passwort Wiederholen"
                                    required
                                />
                            </div>

                            <button type="submit" class="primary">Bestätigen</button>
                        </form>
                    </div>
                </div>
            </div>

            <div class="fullbleed center-aligning center-justifying vertical layout scrim" ?hidden=${!this._loading}>
                <ptc-ui-spinner ?active=${this._loading}></ptc-ui-spinner>
            </div>
        `;
    }
}
